module.exports = __webpack_public_path__ + "static/media/blogging-platform-wordpress-wordpress-icon-svgrepo-com.02cdc23c.svg";